export const handleShowAlert = (text: string) => {
  alert(text);
};
